import { Expose } from 'class-transformer';
import { BasicUser } from './basic-user-model';
import { ApplicationType, Permissions } from '../../common';

export class AuthUser extends BasicUser {
  @Expose() permissions: Permissions[];
  @Expose() appsType: ApplicationType[];
}
